import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { useTenantStore } from '@/store/tenantStore'
import { getLcAdminHomePath } from '@/utils/roleUtils'

interface Props {
  children: React.ReactNode
}

export function MallOperationGuard({ children }: Props) {
  const user = useAuthStore((state) => state.user)
  const lcMallEnabled = useTenantStore((state) => state.tenantInfo?.lcMallEnabled)

  if (lcMallEnabled === false) {
    const adminHomePath = getLcAdminHomePath(user ?? undefined)
    const redirectPath = adminHomePath.startsWith('/admin/mall') ? '/admin/profile' : adminHomePath
    return <Navigate to={redirectPath} replace />
  }

  return <>{children}</>
}
